/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TDesktopGetNotificationsCountModel, IMappers, TDesktopGetNotificationsCountResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetNotificationsCountDesktopResponse } from '../../../entities/get_for_desktop/GetNotificationsCountDesktopResponse';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createDesktopGetNotificationsCountModel(): TDesktopGetNotificationsCountModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'notification-center',
    pathApi: '/v1/desktop/get-notifications-count/',
    response: {
      '200': {
        contentType: 'json',
      },
      '400': {
        contentType: 'json',
      },
    },
  };
}

export interface IDesktopGetNotificationsCountOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

export async function fetchDesktopGetNotificationsCount<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
}: IDesktopGetNotificationsCountOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TDesktopGetNotificationsCountResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createDesktopGetNotificationsCountModel(),
    config,
  )) as FetchResponse<TDesktopGetNotificationsCountResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetNotificationsCountDesktopResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TDesktopGetNotificationsCountResponse>;
}
